import React, { useState, useRef } from "react";
import {
  Carousel,
} from "antd";
import DOMPurify from "dompurify";
import "./Carousel.css";
const CourouselDemo = (props: any) => {
  const carouselRef = useRef(null);
  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  return (
    <div style={{ width: "100%", maxWidth: "100%" }} data-testid="courosel-demo">
      <div style={{ position: "relative", width: "100%", maxWidth: "100%" }}>
        <div style={{ position: "absolute", top: "50%", left: 0, zIndex: 1 }}>
          <button
            id="carousel-previous-btn"
            onClick={handlePrev}
            style={{ background: "transparent", border: "none", textIndent: "-9999" }}
          >
            Previous
          </button>
        </div>
        <div style={{ position: "absolute", top: "50%", right: 0, zIndex: 1 }}>
          <button
            id="carousel-next-btn"
            onClick={handleNext}
            style={{ background: "transparent", border: "none", textIndent: "-9999" }}
          >
            Next
          </button>
        </div>
        <Carousel
          ref={carouselRef}
          style={{
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            maxHeight: "160px",
          }}
        >
          {props
            ? props.bannerData
              ? props.bannerData.map((item: any) => (
                <div key={item.slide}>
                  <div
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      position: "relative",
                    }}
                  >
                    <div style={item.contentStyle}>
                      <div
                        role="group"
                        aria-roledescription="slide"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(item.RenderedHTML),
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))
              : ""
            : ""}
        </Carousel>
      </div>
    </div>
  );
};
export default CourouselDemo;
